import { graphql } from 'relay-runtime';

export const productDuplicationTaskQuery = graphql`
    query productDuplicationTaskQueriesTaskQuery($taskId: Long!) {
        productTask(taskId: $taskId) {
            id
            taskID
            type
            status
            taskState
            createdOn
            modifiedOn
            settings {
                sourceProductId
                destinationProductIds
                destinationProducts {
                    id
                    sku
                    name
                    imageUrl
                    statusId
                }
                cloneTemplates
                cloneBulkVariationForm
                assignPricingRules
                salesChannelId
                sellerID
                userID
            }
            progress {
                currentProductId
                totalOperations
                completedOperations
                overallProgress
                startedAt
                lastUpdatedAt
                productProgress {
                    key
                    value {
                        productId
                        productName
                        status
                    }
                }
            }
            result {
                overallStatus
                overallErrorType
                overallErrorMessage
                completedAt
                totalProducts
                successfulProducts
                failedProducts
                productResults {
                    key
                    value {
                        productId
                        productName
                        productSKU
                        status
                        errorType
                        errorMessage
                        newProductId
                    }
                }
            }
        }
    }
`;

export const productDuplicationTasksQuery = graphql`
    query productDuplicationTaskQueriesListQuery($status: Int, $type: String) {
        productTasks(status: $status, type: $type) {
            id
            taskID
            type
            status
            taskState
            createdOn
            modifiedOn
            settings {
                sourceProductId
                destinationProductIds
                cloneTemplates
                cloneBulkVariationForm
                assignPricingRules
                salesChannelId
                sellerID
                userID
            }
            progress {
                totalOperations
                completedOperations
                overallProgress
            }
            result {
                overallStatus
                overallErrorMessage
                completedAt
                totalProducts
                successfulProducts
                failedProducts
            }
        }
    }
`;

export const cancelProductDuplicationTaskMutation = graphql`
    mutation productDuplicationTaskQueriesCancelMutation($taskId: Long!) {
        cancelProductTask(taskId: $taskId)
    }
`;

export const restartProductDuplicationTaskMutation = graphql`
    mutation productDuplicationTaskQueriesRestartMutation($taskId: Long!) {
        restartProductTask(taskId: $taskId) {
            id
            taskID
            type
            status
            taskState
            createdOn
            modifiedOn
            settings {
                sourceProductId
                destinationProductIds
                cloneTemplates
                cloneBulkVariationForm
                assignPricingRules
                salesChannelId
                sellerID
                userID
            }
            progress {
                totalOperations
                completedOperations
                overallProgress
            }
        }
    }
`;

export const deleteProductDuplicationTaskMutation = graphql`
    mutation productDuplicationTaskQueriesDeleteMutation($taskId: Long!) {
        deleteProductTask(taskId: $taskId)
    }
`;

export const createProductDuplicationTaskMutation = graphql`
    mutation productDuplicationTaskQueriesCreateMutation($request: CreateProductTaskRequestInput!) {
        createProductTask(request: $request) {
            id
            taskID
            type
            status
            taskState
            createdOn
            modifiedOn
            settings {
                sourceProductId
                destinationProductIds
                cloneTemplates
                cloneBulkVariationForm
                assignPricingRules
                salesChannelId
                sellerID
                userID
            }
            progress {
                totalOperations
                completedOperations
                overallProgress
            }
        }
    }
`;
